import {
  GetClassScheduleRequest,
  GetClassScheduleResponse,
  IGetClassScheduleRequest,
  IGetClassScheduleResponse
} from "../../compiled";
import {RpcState} from "../RpcState";
import {useState} from "react";
import {useRpcSender} from "../../RpcSender";


export const useGetClassSchedule = () => {
  const rpcSender = useRpcSender();

  const [response, setResponse] = useState<IGetClassScheduleResponse>()
  const [rpcState, setRpcState] = useState<RpcState>({state: 'pending'});

  const send = (request: IGetClassScheduleRequest) => {

    setResponse(undefined);
    setRpcState({state: 'pending'});
    rpcSender.send('get_class_schedule',
        GetClassScheduleRequest.encode(request).finish())
        .then(responseBytes => {
          let response = GetClassScheduleResponse.decode(responseBytes);
          if (!response.okay) {
            setRpcState({state: 'error', message: "Server error, please try again."});
            return;
          }

          setResponse(response);
          setRpcState({state: 'success'})
        })
        .catch(e => {
          console.log('appointments error', e)
          setRpcState({state: 'error', message: "Network error, please try again."});
        })
  }
  
  return {rpcState, send, response};
}